import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { OrganizationContactRegistrationForm } from 'containers/forms/registration'
import { apiCodeLists, apiCommon, apiConfiguration, apiLeaders } from '../../../helpers/decorators/api'
import { compose } from 'recompose'
import { connect } from 'react-redux'

const enhance = compose(
  apiCommon(),
  apiConfiguration(),
  apiLeaders(),
  apiCodeLists(['genders', 'titles', 'employmentStatuses', 'nationalities', 'phoneTypes'], {
    public: true
  }),
  connect(
  state => ({
    organizationContactRegistration: state.api.leaders.orgContactRegistration
  }), null
))

class OrganizationContactRegistration extends Component {
  static propTypes = {
    getRegistrationInfo: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    common: PropTypes.object,
    onGetConfigurationValue: PropTypes.func,
    configuration: PropTypes.object,
    organizationContactRegistration: PropTypes.object
  }

  render() {
    const { getRegistrationInfo, codeLists, common, onGetConfigurationValue, configuration, organizationContactRegistration } = this.props

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[<OrganizationContactRegistrationForm organizationContactRegistration={organizationContactRegistration} configuration={configuration} onGetConfigurationValue={onGetConfigurationValue} codeLists={codeLists} common={common} getRegistrationInfo={getRegistrationInfo} location={this.props.location} />]}
        colWidth="1024px"
      />
    )
  }
}

export default enhance(OrganizationContactRegistration)
